"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var taskTemplates;
        (function (taskTemplates) {
            var map;
            (function (map) {
                class InitArgs {
                    constructor() {
                        this.latLonUser = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    appn.tasks.initAddressMap({
                        completeAtLot: 'Wizard_Template_Task_CompleteAtLot',
                        completeAtText: 'Wizard_Template_Task_CompleteAtText',
                        completeAtCountry: 'Wizard_Template_Task_CompleteAtCountry',
                        completeAtLat: 'Wizard_Template_Task_CompleteAtLat',
                        completeAtLon: 'Wizard_Template_Task_CompleteAtLon'
                    }, _initArgs.latLonUser, true);
                }
                map.init = init;
            })(map = taskTemplates.map || (taskTemplates.map = {}));
        })(taskTemplates = views.taskTemplates || (views.taskTemplates = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
